<!-- 2 columns form -->
<form name="offerform" [formGroup]="offerForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Equb Sales Offer</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" (click)="reset()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-7">


          <fieldset>
            <legend class="text-semibold">
              <i class="icon-list position-left"></i> Offers
            </legend>


            <table class="table datatable-column-search-inputs">
              <thead>
                <tr>
                  <th>Equb</th>
                  <th>Winner</th>
                  <th>Buyer</th>
                  <th>Offer Price</th>
                  <th>Status</th>
                  <th>Remark</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let offer of offers | paginate: { id: 'offers',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                  <td>{{offer?.sale?.data?.award.data.ekub.data.ekub_id}}</td>
                  <td>{{offer?.sale?.data?.award.data.winner.data.username}} - {{offer?.sale?.data?.award.data.code}}</td>
                  <td>{{offer?.user.data.username}} - {{offer?.code}}</td>
                  <td>{{offer.offered_price}} ETB</td>
                  <td>
                    <span class="label label-block bg-success "
                      *ngIf="offer.status === 'Active' || offer.status === 'active'">{{offer.status}}</span>
                    <span class="label label-block bg-danger"
                      *ngIf="offer.status === 'Cancelled' || offer.status === 'cancelled'">{{offer.status}}</span>
                    <span class="label label-block bg-primary"
                      *ngIf="offer.status === 'Accepted' || offer.status === 'accepted'">{{offer.status}}</span>
                  </td>
                  <td>{{offer.remark}}</td>
                  <td class="text-center">
                    <ul class="icons-list">
                      <li class="dropdown">
                        <a href="" class="dropdown-toggle" data-toggle="dropdown">
                          <i class="icon-menu9"></i>
                        </a>

                        <ul class="dropdown-menu dropdown-menu-right">
                          <li>
                            <!--  <a href="" [routerLink]="['/offeradd']" [queryParams]="{'id':offer.id}"> -->
                            <a href="javascript:void(0);" (click)="editOffer(offer)">
                              <i class="icon-file-pdf"></i>Update</a>
                          </li>
                          <li>
                            <a href="">
                              <i class="icon-file-excel"></i>Delete</a>
                          </li>
                          <li class="dropdown-submenu dropdown-submenu-left">
                            <a href="javascript:void(0);">Change Status</a>
                            <ul class="dropdown-menu">
                              <li>
                                <a (click)="changeStatus(offer.id,'active')">
                                  <i class="icon-shuffle"></i> Active</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(offer.id,'cancelled')">
                                  <i class="icon-shuffle"></i> Cancelled</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(offer.id,'accepted')">
                                  <i class="icon-shuffle"></i> Accepted</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>

                    </ul>
                  </td>
                </tr>
                <tr *ngIf="offers?.length <=0">
                  <td colspan="11" class="text-center"> <i class="icon-info22">&nbsp;</i>No Offers given yet!</td>
                </tr>
              </tbody>
            </table>


            <div class="row">
              <div class="text-center">

                <pagination-controls id="offers" (pageChange)="pageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>

          </fieldset>
        </div>

        <div class="col-md-1"></div>
        <div class="col-md-5">

          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Offer
            </legend>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Award to sale: </span>
                  <ng-select [items]="sales" placeholder="" formControlName="sale" (change)="getWinner($event)"
                    bindValue="id" bindLabel="text" required>
                  </ng-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label"> Buyer: </span>
                  <ng-select [items]="ekubMembers" placeholder="" formControlName="user" (change)="setBuyer($event)" bindValue="id"
                    bindLabel="text"></ng-select>
                  <!--  <div class="help-block" *ngIf="buyer.invalid && (buyer.dirty || buyer.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> buyer is required
                    </p>
                  </div> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group required">
                  <span class="control-label"> Offered Price: </span>
                  <input type="number" name="offered_price" required formControlName="offered_price"
                    class="form-control" placeholder="offer appearing offered price">
                  <div class="help-block"
                    *ngIf="offered_price.invalid && (offered_price.dirty || offered_price.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Offer price is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Status: </span>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select offer status">
                    <option selected disabled>Status:</option>
                    <option value="active">Active</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="accepted">Accepted</option>
                  </select>
                  <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Offer status is required.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">

              <div class="form-group">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ." required></textarea>
                <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Please write small description about the offer
                  </p>
                </div>
              </div>
            </div>

          </fieldset>

          <div class="text-right">

            <!--  <button class="btn bg-slate-800" (click)="addNews(offer.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
              <span *ngIf="!offer.id">Save News</span>
              <span *ngIf="offer.id">Update News</span>
              <i class="icon-floppy-disk position-right"></i>
            </button> -->
            <button class="btn bg-slate-800" (click)="addOffer()" type="submit" data-style="slide-right"
              [disabled]="offerForm.invalid">
              <span *ngIf="operation=='add'">Save Offer</span>
              <span *ngIf="operation!='add'">Update Offer</span>
              <i class="icon-floppy-disk position-right"></i>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</form>
<!-- /2 columns form -->